<template>
<v-card elevation="0" hover>
    <v-card-title  primary-title><h5>{{formmatedDate}}</h5></v-card-title>
    <v-card-text  :ref="'log-' + aLog.id" v-html="rawHtml(aLog.log)" contenteditable="true" class="terminal" @keyup="updateDebounced(aLog.id);markEditing()"/>    
</v-card>
</template>

<script>
import {updateCapLog} from '../services/caplogsServices'
import * as _ from 'lodash'

export default {
    props : ['aLog'],
    created : function(){
        this.updateDebounced = _.debounce(this.updateLog,1500,{maxWait:10000})
    },
    methods : {
        rawHtml(log){
            return `${log}<br>`
        },
        updateLog(id){
            console.log("Updating " + id)
            updateCapLog(id, this.$refs['log-' + id].innerHTML)            
        },
        markEditing(){
            this.$store.dispatch('editing')
        }
    },
    computed : {
        formmatedDate(){
            console.log("The log date for existing: ", this.aLog.updatedAt)
            let d = new Date(this.aLog.updatedAt)
             return d.getFullYear()  + "/" + (d.getMonth() + 1) + "/" + d.getDate() + " - " + d.getHours() + ":" + d.getMinutes();            
        }
    }
}
</script>

<style scoped>
.terminal {
  outline: 0px solid transparent;
}

.newLog{
    border : 1px solid gray
}

p{
    padding: 0px;
}
</style>

